// TelcoTrack – Balíčky záfuku pro typ STAVAJICI (list STAVAJICI v CSV, sloupec K = název balíčku).
// Generováno: npm run generate-stavajici-zafuk-bundles (v kořeni cubby-app).

export type { StavajiciBundleMaterialLine, StavajiciZafukBundle } from './material-stavajici-bundles.generated';
export { STAVAJICI_ZAFUK_BUNDLES } from './material-stavajici-bundles.generated';
